import React, { useState, useEffect } from "react";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import * as withdrawalServices from "../../services/withdrawalServices";
import { useTranslation } from "react-i18next";

const ManualWithdrawalHistory = () => {
    const { t } = useTranslation();
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(true);

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Manual Transfer History", url: "" },
    ];

    // Fetch history
    useEffect(() => {
        setLoader(true);
        withdrawalServices
            .History({})
            .then((response) => {
                if (response?.success) {
                    setList(response.data.history || response.data.list || []);
                }
                setLoader(false);
            })
            .catch((err) => {
                console.log("Error fetching history:", err);
                setLoader(false);
            });
    }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />

            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label mb-0">Manual Transfer History</h6>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Astrologer</th>
                                        <th>Amount</th>
                                        <th>Method</th>
                                        <th>Date</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : list.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No manual transfer history found
                                            </td>
                                        </tr>
                                    ) : (
                                        list.map((row, i) => (
                                            <tr key={row.id}>
                                                <td>{i + 1}</td>
                                                <td>
                                                    <strong>{row.astrologer_details?.name || "N/A"}</strong>
                                                    <br />
                                                    <small className="text-muted">{row.astrologer_details?.email}</small>
                                                </td>
                                                <td>
                                                    <strong>
                                                        {row.astrologer_details?.astrologer_wallet?.currency_type === 'USD' ? '$' : '₹'}{parseFloat(row.amount || 0).toLocaleString(row.astrologer_details?.astrologer_wallet?.currency_type === 'USD' ? "en-US" : "en-IN")}
                                                    </strong>
                                                </td>
                                                <td>
                                                    <span className="badge bg-info">{row.method?.toUpperCase()}</span>
                                                </td>
                                                <td>{formateDateWithMonth(row.createdAt)}</td>
                                                <td style={{ maxWidth: "200px", whiteSpace: "normal" }}>
                                                    {row.remarks || <em className="text-muted">No remarks</em>}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ManualWithdrawalHistory;
